import {
  TOGGLE_SIDEBAR,
  SET_MENU_ITEM,
  OPEN_MENU_KEY_EQUAL_ROUTE,
  UPDATE_WINDOW_WIDTH
} from "@/store/mutation-types";

export default {
  [UPDATE_WINDOW_WIDTH]: (state, width) => {
    state.width = width;
  },
  [TOGGLE_SIDEBAR]: (state, value) => {
    if (state.open) {
      document.getElementsByTagName("body")[0].classList.add("fixed-left");
      document
        .getElementsByTagName("body")[0]
        .classList.remove("fixed-left-void");
    } else {
      document.getElementsByTagName("body")[0].classList.add("fixed-left-void");
      document.getElementsByTagName("body")[0].classList.remove("fixed-left");
    }
    state.open = value;
  },
  [SET_MENU_ITEM]: (state, menuList) => {
    state.menuList = { ...menuList };
  },
  [OPEN_MENU_KEY_EQUAL_ROUTE]: (state, key) => {
    state.menuList.menuItems.map(item => {
      item.subMenuShow = false;
    });
    let i = state.menuList.menuItems.findIndex(item => {
      return item.key === key;
    });
    state.menuList.menuItems[i].subMenuShow = true;
  }
};
